import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesevent/event031.jpeg", alt: "Event" },
  { src: "/imagesevent/event032.jpeg", alt: "Event" },
  { src: "/imagesevent/event033.jpeg", alt: "Event" },
  { src: "/imagesevent/event034.jpeg", alt: "Event" },
  { src: "/imagesevent/event035.jpeg", alt: "Event" },
  { src: "/imagesevent/event036.jpeg", alt: "Event" },
  { src: "/imagesevent/event037.jpeg", alt: "Event" },
  { src: "/imagesevent/event038.jpeg", alt: "Event" },
  { src: "/imagesevent/event039.jpeg", alt: "Event" },
  { src: "/imagesevent/event040.jpeg", alt: "Event" },
 
  // Add more images gallery01
];

function Event04() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Event04;
